import React, { useEffect } from 'react';
import { UrgencyBar } from '../components/UrgencyBar';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { ScienceSection } from '../components/ScienceSection';
import { TransformationSection } from '../components/TransformationSection';
import { ValueStackSection } from '../components/ValueStackSection';
import { BridgeSection } from '../components/BridgeSection';
import { SocialProofSection } from '../components/SocialProofSection';
import { PricingSection } from '../components/PricingSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { AuthorSection } from '../components/AuthorSection';
import { Footer } from '../components/Footer';
import { FloatingCountdown } from '../components/FloatingCountdown';
import { initMetaPixel, trackPageView } from '../utils/metaPixel';
export function SalesPage() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-[#fdfbf7] font-sans selection:bg-[#dc4a3d] selection:text-white" data-id="element-479">
      <UrgencyBar data-id="element-480" />
      <HeroSection data-id="element-481" />
      <PainSection data-id="element-482" />
      <ScienceSection data-id="element-483" />
      <TransformationSection data-id="element-484" />
      <ValueStackSection data-id="element-485" />
      <SocialProofSection data-id="element-486" />
      <PricingSection data-id="element-487" />
      <GuaranteeSection data-id="element-488" />
      <FAQSection data-id="element-489" />
      <AuthorSection data-id="element-490" />
      <Footer data-id="element-491" />
    </div>;
}